let wizardSessionStartTs = null;
let activeWizardSessionProviderCount = 0;
export const acquireWizardSessionStartTs = () => {
  if (wizardSessionStartTs === null) {
    wizardSessionStartTs = Date.now();
  }
  activeWizardSessionProviderCount += 1;
  return wizardSessionStartTs;
};
export const releaseWizardSessionStartTs = () => {
  if (activeWizardSessionProviderCount > 0) {
    activeWizardSessionProviderCount -= 1;
  }
  if (activeWizardSessionProviderCount === 0) {
    wizardSessionStartTs = null;
  }
};
export const getWizardSessionStartTs = () => wizardSessionStartTs;
//# sourceMappingURL=wizard-session.js.map